module.exports = __webpack_public_path__ + "img/tech-14.57755b7d.jpg";